import { AlertTriangle, CheckCircle2, Info } from "lucide-react";
import type { ReactNode } from "react";

export function Notice({
  tone = "info",
  title,
  children,
  actions,
}: {
  tone?: "info" | "success" | "warning" | "danger";
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
}) {
  const Icon = tone === "success" ? CheckCircle2 : tone === "warning" || tone === "danger" ? AlertTriangle : Info;
  return (
    <aside className={`notice notice-${tone}`}>
      <Icon aria-hidden="true" />
      <div>
        <strong>{title}</strong>
        {children && <div className="notice-body">{children}</div>}
        {actions && <div className="notice-actions">{actions}</div>}
      </div>
    </aside>
  );
}
